import { useLocation, Link, useNavigate } from "react-router-dom";

const Breadcrumbs = () => {
  const location = useLocation();
  const state = location.state || {};
  const pathnames = location.pathname.split("/").filter(Boolean);
  const { categoryName, subCategoryName } = state;
  const navigate = useNavigate();
  const formatLabel = (label) => {
    return label
      .split("-")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const getLabel = (segment, index) => {
    if (index === 0 && categoryName) return formatLabel(categoryName);
    if (index === 1 && subCategoryName) return formatLabel(subCategoryName);

    const cleanSegment = decodeURIComponent(segment).replace(/-\d+$/, ""); // remove trailing ID
    return formatLabel(cleanSegment);
  };

  const handleClick = (index) => {
    if (index === 0) {
      // Navigate to explore-solutions section on home
      navigate("/#explore-solutions");
    } else {
      // Build path up to the current index
      const path = `/${pathnames.slice(0, index + 1).join("/")}`;
      navigate(path);
    }
  };

  return (
    <nav className="text-sm breadcrumbs p-4">
      <ul className="flex gap-2 text-gray-600">
        <li>
          <Link to="/" className="text-blue-600 hover:underline">
            Home
          </Link>
        </li>
        {pathnames.map((segment, index) => {
          const isLast = index === pathnames.length - 1;
          const label = getLabel(segment, index);

          return (
            <li key={index} className="flex items-center">
              {/* <span className="mx-1">/</span> */}
              {isLast ? (
                <span className="capitalizen">{label}</span>
              ) : (
                <Link
                  onClick={() => handleClick(index)}
                  className="text-blue-600 hover:underline capitalize"
                >
                  {label}
                </Link>
              )}
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default Breadcrumbs;
